'use strict';

module.exports = [
    { label: 'ALABAMA', code: 'AL' },
    { label: 'ALASKA', code: 'AK' },
    { label: 'AMERICAN SAMOA', code: 'AS' },
    { label: 'ARIZONA', code: 'AZ' },
    { label: 'ARKANSAS', code: 'AR' },
    { label: 'CALIFORNIA', code: 'CA' },
    { label: 'COLORADO', code: 'CO' },
    { label: 'CONNECTICUT', code: 'CT' },
    { label: 'DELAWARE', code: 'DE' },
    { label: 'DISTRICT OF COLUMBIA', code: 'DC' },
    { label: 'FEDERATED STATES OF MICRONESIA', code: 'FM' },
    { label: 'FLORIDA', code: 'FL' },
    { label: 'GEORGIA', code: 'GA' },
    { label: 'GUAM', code: 'GU' },
    { label: 'HAWAII', code: 'HI' },
    { label: 'IDAHO', code: 'ID' },
    { label: 'ILLINOIS', code: 'IL' },
    { label: 'INDIANA', code: 'IN' },
    { label: 'IOWA', code: 'IA' },
    { label: 'KANSAS', code: 'KS' },
    { label: 'KENTUCKY', code: 'KY' },
    { label: 'LOUISIANA', code: 'LA' },
    { label: 'MAINE', code: 'ME' },
    { label: 'MARSHALL ISLANDS', code: 'MH' },
    { label: 'MARYLAND', code: 'MD' },
    { label: 'MASSACHUSETTS', code: 'MA' },
    { label: 'MICHIGAN', code: 'MI' },
    { label: 'MINNESOTA', code: 'MN' },
    { label: 'MISSISSIPPI', code: 'MS' },
    { label: 'MISSOURI', code: 'MO' },
    { label: 'MONTANA', code: 'MT' },
    { label: 'NEBRASKA', code: 'NE' },
    { label: 'NEVADA', code: 'NV' },
    { label: 'NEW HAMPSHIRE', code: 'NH' },
    { label: 'NEW JERSEY', code: 'NJ' },
    { label: 'NEW MEXICO', code: 'NM' },
    { label: 'NEW YORK', code: 'NY' },
    { label: 'NORTH CAROLINA', code: 'NC' },
    { label: 'NORTH DAKOTA', code: 'ND' },
    { label: 'NORTHERN MARIANA ISLANDS', code: 'MP' },
    { label: 'OHIO', code: 'OH' },
    { label: 'OKLAHOMA', code: 'OK' },
    { label: 'OREGON', code: 'OR' },
    { label: 'PALAU', code: 'PW' },
    { label: 'PENNSYLVANIA', code: 'PA' },
    { label: 'PUERTO RICO', code: 'PR' },
    { label: 'RHODE ISLAND', code: 'RI' },
    { label: 'SOUTH CAROLINA', code: 'SC' },
    { label: 'SOUTH DAKOTA', code: 'SD' },
    { label: 'TENNESSEE', code: 'TN' },
    { label: 'TEXAS', code: 'TX' },
    { label: 'UTAH', code: 'UT' },
    { label: 'VERMONT', code: 'VT' },
    { label: 'VIRGIN ISLANDS', code: 'VI' },
    { label: 'VIRGINIA', code: 'VA' },
    { label: 'WASHINGTON', code: 'WA' },
    { label: 'WEST VIRGINIA', code: 'WV' },
    { label: 'WISCONSIN', code: 'WI' },
    { label: 'WYOMING', code: 'WY' }
];
